import React, { memo } from 'react'
import Link from 'components/CommonUI/Link/Link'

import {
  GetHelpIcon,
  // PrivacyIcon,
  // TermIcon,
} from 'components/CommonUI/svgIcons'
import { routingConstants } from 'constants/routingConstants'

const TermPrivacyLinks = () => {
  return (
    <div className="term_privacy_container">
      <Link className="term_privacy_link" to={routingConstants.helpSupport}>
        <GetHelpIcon className="term_privacy_icon" />
        Get help
      </Link>
      {/*<Link className="term_privacy_link" to="/">*/}
      {/*  <PrivacyIcon className="term_privacy_icon" />*/}
      {/*  Privacy*/}
      {/*</Link>*/}
      {/*<Link className="term_privacy_link" to="/">*/}
      {/*  <TermIcon className="term_privacy_icon" />*/}
      {/*  Terms*/}
      {/*</Link>*/}
    </div>
  )
}

export default memo(TermPrivacyLinks)
